<div class="w-full">
    <mat-form-field class="w-full" [formGroup]="group">
        <input matInput [formControlName]="field.name" [placeholder]="field.label" [type]="field.inputType" (change)="onChange($event)"
        [disabled]="field.disabled" >
        <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
            <mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
        </ng-container>
    </mat-form-field>
</div>
